function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  rx: 14,
  fill: "#174ABC"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9625 20.75C18.35 20.75 16.7782 20.3905 15.2473 19.6715C13.7158 18.953 12.3595 18.003 11.1785 16.8215C9.997 15.6405 9.047 14.2842 8.3285 12.7527C7.6095 11.2217 7.25 9.65 7.25 8.0375C7.25 7.8125 7.325 7.625 7.475 7.475C7.625 7.325 7.8125 7.25 8.0375 7.25H11.075C11.25 7.25 11.4063 7.30625 11.5438 7.41875C11.6813 7.53125 11.7625 7.675 11.7875 7.85L12.275 10.475C12.3 10.65 12.297 10.8092 12.266 10.9527C12.2345 11.0967 12.1625 11.225 12.05 11.3375L10.2312 13.175C10.7562 14.075 11.4158 14.9187 12.2098 15.7062C13.0033 16.4937 13.875 17.175 14.825 17.75L16.5875 15.9875C16.7 15.875 16.847 15.7905 17.0285 15.734C17.2095 15.678 17.3875 15.6625 17.5625 15.6875L20.15 16.2125C20.325 16.25 20.4688 16.3342 20.5812 16.4653C20.6937 16.5967 20.75 16.75 20.75 16.925V19.9625C20.75 20.1875 20.675 20.375 20.525 20.525C20.375 20.675 20.1875 20.75 19.9625 20.75ZM9.51875 11.75L10.7563 10.5125L10.4375 8.75H8.76875C8.83125 9.2625 8.91875 9.76875 9.03125 10.2688C9.14375 10.7688 9.30625 11.2625 9.51875 11.75ZM16.2313 18.4625C16.7188 18.675 17.2157 18.8438 17.7222 18.9688C18.2282 19.0938 18.7375 19.175 19.25 19.2125V17.5625L17.4875 17.2062L16.2313 18.4625Z",
  fill: "white"
});

function SvgFooterIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon1);
export default __webpack_public_path__ + "static/media/footer_icon1.bdde0378.svg";
export { ForwardRef as ReactComponent };